import React from "react";

import { ShippingContextProvider } from "../../hooks";
import ShippingPageContent from "./ShippingPageContent";

export const ShippingPage = ({ defaultLocation }) => {
  return (
    <ShippingContextProvider>
      <ShippingPageContent defaultLocation={defaultLocation} />
    </ShippingContextProvider>
  );
};

export default ShippingPage;
